// src/i18n/es/activityMonitor.ts

const activityMonitor = {
  name: 'Actividad',
  title: 'Monitor de Actividad en Vivo',
  subtitle: 'Panel de actividad de dispositivos en tiempo real',
  
  filters: {
    hotel: 'Instalación',
    group: 'Grupo',
    deviceType: 'Tipo de Dispositivo',
    status: 'Estado de Actividad',
    allHotels: 'Todas las Instalaciones',
    allTypes: 'Todos los Tipos',
    allStatuses: 'Todos los Estados',
    timeRange: 'Período',
    allGroups: 'Todos los grupos · última hora',
    ungrouped: 'Sin grupo',
  },
  
  actions: {
    toggleFilters: 'Alternar Filtros',
    refresh: 'Actualizar',
    viewJourney: 'Ver Recorrido',
    viewEvents: 'Ver Eventos',
    viewErrors: 'Ver Errores',
    fullscreen: 'Pantalla Completa',
    exitFullscreen: 'Salir de Pantalla Completa',
    groupMonitor: 'Monitor de Grupo',
    onlyAttention: 'Solo atención',
    showAll: 'Ver todas',
    viewDetail: 'Ver detalle',
    viewSettings: 'Opciones de vista',
  },

  // Read-only panel view options (settings icon)
  settings: {
    fitWidth: 'Ajustar al ancho de pantalla',
  },

  // Attention lifecycle (acknowledge / keep)
  attention: {
    acknowledge: 'Acusar',
    keep: 'Mantener',
    unmark: 'Quitar',
    mark: 'Marcar',
    pinned: 'Fijado',
    acknowledged: 'Atendido',
    expired: 'Sin atender',
  },

  // Operational health verdict (banner + counters)
  health: {
    allOperational: 'Todo en funcionamiento',
    needsAttention: '%{count} unidad requiere atención |||| %{count} unidades requieren atención',
    allOnlineNoSessions: 'Todas las unidades en línea · sin sesiones activas',
    active: 'Activas',
    idle: 'En reposo',
    offline: 'Sin conexión',
    errorsToday: 'Errores hoy',
    attentionTooltip: 'Unidades sin conexión o con errores',
  },

  hasErrors: 'Hay errores en este dispositivo',
  
  summary: {
    total: 'Total de Dispositivos',
    active: 'Activos',
    idle: 'Inactivos',
    offline: 'Desconectados',
    totalDevices: 'Dispositivos',
    totalSessions: 'Sesiones',
    activeSessions: 'Activas',
    completedSessions: 'Completadas',
    flowingOk: 'todas fluyen con normalidad',
    finishedOk: 'completadas correctamente',
  },

  status: {
    active: 'Activo (última actividad hace %{minutes} min)',
    idle: 'Inactivo (%{minutes} min sin actividad)',
    offline: 'Desconectado (%{minutes} min)',
    inactive: 'Dispositivo Inactivo',
    deviceInactive: 'Dispositivo Desactivado',
  },
  
  statusOptions: {
    active: 'Activo',
    idle: 'Inactivo',
    offline: 'Desconectado',
    inactive: 'Desactivado',
  },
  
  time: {
    justNow: 'Ahora mismo',
    minutesAgo: 'Hace %{count} min',
    hoursAgo: 'Hace %{count} hora |||| Hace %{count} horas',
    daysAgo: 'Hace %{count} día |||| Hace %{count} días',
  },
  
  labels: {
    sessions: 'sesiones',
    button: 'Etiquetas',
    free: 'Sin categoría',
  },

  reservation: 'Reserva',
  section: 'Sección',
  recentActivity: 'Actividad Reciente',
  lastEvent: 'Último Evento',
  sessions: 'sesiones',
  activeSessions: 'sesiones activas',
  completedSessions: 'sesiones completadas',
  noActiveSessions: 'No hay sesiones activas',
  eventTimeline: 'Línea de tiempo',
  completedAt: 'Completado',
  
  sections: {
    s: 'Búsqueda de la reserva',
    r: 'Habitación',
    i: 'Identificación',
    f: 'Firma',
    u: 'Extras',
    b: 'Resumen de la cuenta',
    p: 'Pago',
    k: 'Llave',
    checkin: 'Check-in',
    checkout: 'Check-out',
    keydispensing: 'Dispensación de Llaves',
    invoicegeneration: 'Generación de Factura',
    guestregistration: 'Registro de Huésped',
    // Redesigned operations panel — section headers
    attention: 'Requieren atención ahora',
    inProgress: 'Sesiones en curso',
    finished: 'Finalizadas recientemente',
    stepIdentify: 'Identificándose',
    stepPay: 'Pagando',
    stepKey: 'Recogiendo la llave',
    completedRecent: 'Completado · reciente',
    emptyStep: 'Nadie en este paso ahora mismo',
    emptyDevice: 'Sin actividad',
    idleGroup: 'Sin actividad',
    idleTitle: 'Sin actividad',
    idleSubtitle: 'Todo en orden. Los puntos están listos para el próximo huésped.',
  },
  
  metrics: {
    eventsMin: 'Eventos/min',
    avgTime: 'Tiempo Prom',
  },
  
  messages: {
    noRecentActivity: 'Sin actividad en las últimas 24 horas',
    noDevices: 'No se encontraron dispositivos',
    deviceOffline: 'El dispositivo está desconectado',
    noActivity: 'Sin actividad reciente',
    selectDifferentFilters: 'Pruebe a seleccionar diferentes filtros para ver dispositivos',
    liveMonitoring: 'Monitoreo en Vivo',
    moreEvents: 'Más eventos',
  },
  
  sessionStatus: {
    active: 'Activa',
    completed: 'Completada',
    abandoned: 'Sin completar',
  },
  
  completed: 'Completado',
  
  eventCodes: {
    HB: 'Latido',
    
    // Check-in flow
    CI_START: 'Check-In - Inicio',
    CI_SEARCH: 'Buscar Reserva',
    CI_IDENTIFY: 'Identificación',
    CI_SIGN: 'Firma',
    CI_UPSELL: 'Venta Adicional',
    CI_COMP: 'Check-In - Fin',
    
    // Pre-check-in flow
    PC_LINK_OPEN: 'Enlace abierto',
    PC_START: 'Pre-Check-In - Inicio',
    PC_SEARCH: 'Buscar Reserva',
    PC_IDENTIFY: 'Identificación',
    PC_SIGN: 'Firma',
    PC_UPSELL: 'Venta Adicional',
    PC_COMP: 'Pre-Check-In - Fin',
    
    // Payment
    PM_SUCCESS: 'Pago',
    PM_ERROR: 'Error de Pago',
    
    // Key delivery
    KD_SUCCESS: 'Llave Dispensada',
    KD_ERROR: 'Error de Llave',
    KD_REBOOT: 'Reinicio del Dispensador',

    // Section navigation (kiosk)
    SECTION_ENTER: 'Entrada a Sección',
    SECTION_EXIT: 'Salida de Sección',

    // Operational / errors
    PMS_RECOVERY_FAILED: 'Fallo de Recuperación',
    PMS_RESERVATION_NOT_FOUND: 'Reserva no Encontrada',
    PMS_ROOM_NOT_READY: 'Habitación no Preparada',
    PMS_EARLY_ARRIVAL: 'Llegada Anticipada',
    PMS_CHECKIN_FAILED: 'No se ha podido finalizar el Check-in',
    PMS_TIMEOUT: 'El sistema de reservas del hotel no respondió a tiempo',
    ERR: 'Error',
    AB: 'Abandonado',

    // Kiosk 1.1.9 error codes (telemetry contract §4)
    PMS_ADD_GUEST_FAILED: 'Error al registrar al huésped',
    PMS_SEND_DOCS_FAILED: 'Error al enviar los documentos',
    TRAVELER_FORM_GENERATION_FAILED: 'Error al generar el parte de viajeros',
    STAY_SAVE_FAILED: 'Error al guardar la estancia',
    CHECKIN_PIPELINE_FAILED: 'Error en el proceso de check-in',
    PMS_BOOKING_FORM_NOT_FOUND: 'Pre-registro no encontrado',
    PMS_TOURIST_TAX_FAILED: 'Error al calcular la tasa turística',
    UI_IDLE_RESET: 'Reinicio por inactividad',
    UI_SESSION_EXPIRED: 'Sesión caducada',
    SCAN_RETRIES_EXHAUSTED: 'Reintentos de escaneo agotados',
    PAYMENT_FAILED: 'Error al registrar el pago',
    PAYMENT_CONFIRM_FAILED: 'Error al confirmar el pago',
    PAYMENT_TERMINAL_ERROR: 'Error del terminal de pago',
    PAYMENT_STATUS_NULL: 'Pago abortado',
    PAYMENT_POLLING_TIMEOUT: 'Tiempo de espera del pago agotado',
    PMS_REVERSE_CHECKIN_FAILED: 'Error al revertir el check-in',
    CASH_JAM: 'Atasco en la máquina de efectivo',
    CASH_FRAUD: 'Posible intento de fraude',
    CASH_DISPENSE_ERROR: 'Error al dispensar efectivo',
    CASH_INIT_ERROR: 'Error al inicializar la máquina de efectivo',
    CASH_AMOUNT_ERROR: 'Error de importe en efectivo',
    CASH_COMM: 'Error de comunicación con la máquina de efectivo',
    CASH_NO_CHANGE: 'Sin cambio disponible',
    CASH_INSUFFICIENT_FUNDS: 'Fondos de efectivo insuficientes',
    PMS_CHECKOUT_FAILED: 'Check-out rechazado',
    PMS_CHECKOUT_OUTSTANDING_BALANCE: 'Saldo pendiente',
    PMS_CHECKOUT_EARLY_BLOCKED: 'Check-out anticipado bloqueado',
    PMS_INVOICE_INVALID_INFO: 'Datos de facturación no válidos',
    PMS_INVOICE_NO_SERIES: 'Serie de facturación no configurada',
    PMS_INVOICE_ROOM_INVALID: 'Habitación de la factura no válida',
    PMS_INVOICE_CHARGES_UNAVAILABLE: 'Cargos no disponibles',
    PMS_INVOICE_NOT_FOUND: 'Factura no encontrada',
    PMS_INVOICE_SECOND_SURNAME_REQUIRED: 'Se requiere segundo apellido',
    UPSELL_ORDER_FAILED: 'Error en pedido de servicio adicional',
    UPSELL_EXTERNAL_FAILED: 'Error al confirmar con el sistema externo',
    UPSELL_NOT_AVAILABLE: 'Servicio adicional no disponible',
    LOCKS_COMM: 'Error de comunicación con cerraduras',
    LOCKS_AUTH_ERROR: 'Error de autenticación con cerraduras',
    LOCKS_READ_ERROR: 'Error de lectura del sistema de cerraduras',
    KD_UID_NOT_REGISTERED: 'Registro de tarjeta rechazado',
    KD_DIGITAL_KEY_DELIVERY_FAILED: 'Error al entregar la llave digital',
    KEY_DISPENSE_FAILED: 'Error al dispensar la llave',
    SCANNER_COMM: 'Error de comunicación con el escáner',
    QR_READER_COMM: 'Error de comunicación con el lector QR',
    SIGNATURE_COMM: 'Error de comunicación con el servicio de firma',
    PRINTER_FAILED: 'Fallo de impresora',
    PRINTER_PAPER_OUT: 'Impresora sin papel',
    PRINTER_PAPER_LOW: 'Queda poco papel en la impresora',
    NETWORK_UNREACHABLE: 'Kiosco fuera de servicio (red)',
    NETWORK_RECOVERED: 'Conexión recuperada',
    KIOSK_NOT_REGISTERED: 'Kiosco no registrado',
    KIOSK_INACTIVE: 'Kiosco inactivo',
    KIOSK_BLOCKED_TEMPORARY: 'Kiosco bloqueado temporalmente',
    KIOSK_BLOCK_RECOVERED: 'Bloqueo del kiosco levantado',
  },
  
  channels: {
    online: 'Pre-check-in online',
    airLobby: 'Air Lobby',
    kiosk: 'Kiosco',
    mobileKiosk: 'Kiosco en el móvil',
    dispenser: 'Dispensador de llaves',
  },

  // Global KPIs
  kpi: {
    checkIns: 'Check-ins',
    keys: 'Llaves',
    dispenserOps: 'Dispensador',
  },

  // Daily statistics
  stats: {
    today: 'Hoy',
    sessions: 'Sesiones',
    successful: 'Exitosas',
    failed: 'Fallidas',
    errors: 'Errores',
    avgDuration: 'Duración prom.',
    keysDelivered: 'Llaves',
  },

  // Session details
  session: {
    room: 'Hab.',
    duration: 'Duración',
    keys: 'Llaves',
    error: 'Error',
    waiting: 'esperando',
    inProgress: 'en curso',
    finished: 'finalizó',
  },

  // Dispenser card
  dispenserCard: {
    keysToday: 'llaves hoy',
    errorsToday: 'errores hoy',
    operations: 'operaciones',
    noOperations: 'Sin operaciones',
    keyDispensed: 'Llave dispensada',
    error: 'Error',
    abandoned: 'Sin completar',
    room: 'Hab.',
    heartbeatInfo: 'Los dispensadores informan cada 30 min. Puede tardar hasta 35 min en detectar una desconexión.',
  },

  // Time range filter
  timeRange: {
    '1h': '1h',
    '6h': '6h',
    '12h': '12h',
    '24h': '24h',
    '48h': '48h',
    '72h': '3d',
    '7d': '7d',
  },

  // Redesigned operations panel — session friction state
  sessionState: {
    error: 'Problema',
    notice: 'Aviso',
    mistake: 'Sin completar',
    slow: 'Lento',
    flowing: 'En curso',
    completed: 'Completado',
    abandoned: 'Sin completar',
  },

  // Journey step labels (guest progress)
  step: {
    search: 'Búsqueda de reserva',
    identify: 'Identificación',
    pay: 'Pago',
    key: 'Llave',
  },

  // Location / point of interaction
  point: {
    checkin: 'Punto de check-in',
    dispenser: 'Entrega de llave',
    dispenserDevice: 'Dispensador de llaves',
    unidentified: 'huésped sin identificar',
  },

  // Grouping mode selector
  view: {
    atencion: 'Atención',
    paso: 'Paso',
    equipo: 'Equipo',
  },

  // List density toggle
  density: {
    comfortable: 'Cómoda',
    compact: 'Compacta',
  },

  // Card arrangement
  layout: {
    grid: 'Cuadrícula',
    columns: 'Columnas',
  },

  // Device connection state (from the backend activityStatus)
  connection: {
    active: 'Conectado',
    idle: 'En reposo',
    offline: 'Desconectado',
  },

  // Human names for the journey sections (from the event metadata 'section',
  // which arrives either as a word like "home" or a single-letter code S/I/F/U/P/K)
  sectionNames: {
    s: 'Inicio',
    i: 'Identificación',
    f: 'Firma',
    u: 'Servicios adicionales',
    p: 'Pago',
    k: 'Entrega de llave',
    r: 'Selección de habitación',
    b: 'Resumen de la cuenta',
    home: 'Inicio',
    identification: 'Identificación',
    identify: 'Identificación',
    search: 'Búsqueda',
    signature: 'Firma',
    sign: 'Firma',
    payment: 'Pago',
    pay: 'Pago',
    upsell: 'Servicios adicionales',
    key: 'Entrega de llave',
    keydelivery: 'Entrega de llave',
    keydispensing: 'Entrega de llave',
    summary: 'Resumen',
    complete: 'Finalización',
    completion: 'Finalización',
  },

  // At-a-glance session detail (modal summary)
  detail: {
    startedAt: 'Inicio',
    elapsed: 'En curso',
    duration: 'Duración',
    reservation: 'Reserva',
    unit: 'Unidad',
    keysDelivered: 'Llaves entregadas',
    channel: 'Canal',
    recentEvents: 'Últimos eventos',
    openJourney: 'Ver recorrido',
    openEvents: 'Ver eventos',
    openLogs: 'Ver registros del dispositivo',
    close: 'Cerrar',
    live: 'En directo',
    // Enriched event detail
    eventDetail: 'Detalle del evento',
    enteredSection: 'Entrada a',
    exitedSection: 'Salida de',
    section: 'Sección',
    room: 'Habitación',
    whatHappened: 'Qué ha pasado',
    recommendation: 'Recomendación',
    technicalInfo: 'Información técnica',
    errorCode: 'Código',
    metadata: 'Datos adicionales',
    noExtraInfo: 'Sin información adicional para este evento.',
    loadingEvents: 'Cargando eventos…',
    tapForDetail: 'Toque un evento para ver el detalle completo',
    copyData: 'Copiar datos',
    copied: 'Datos copiados',
    notification: {
      title: '¿A quién se avisó?',
      sentTo: 'Avisado a',
      notSent: 'No se envió aviso',
      failed: 'Fallo al enviar el aviso',
      channels: {
        email: 'correo',
        sms: 'SMS',
        whatsapp: 'WhatsApp',
        other: 'aviso',
      },
      reasons: {
        ThrottleActive: 'aviso repetido (silenciado temporalmente)',
        NoRecipientsConfigured: 'sin destinatarios configurados',
        ConfigDisabledOrMissing: 'avisos no configurados',
        NotifierNotConfigured: 'envío no configurado',
        NoEnabledChannels: 'sin canales activos',
        ThresholdNotReached: 'umbral no alcanzado',
        DeliveryError: 'error de entrega',
      },
    },
    severity: {
      Critical: 'Crítico',
      High: 'Alto',
      Medium: 'Medio',
      Low: 'Bajo',
      Info: 'Informativo',
      Warning: 'Aviso',
      Error: 'Error',
      Informational: 'Informativo',
    },
  },

  // Device notices — equipment telemetry with no guest session (low/empty hopper,
  // a reboot, a service door open). Shown apart from real sessions.
  deviceNotice: {
    zoneTitle: 'Avisos del equipo',
    attention: 'Requieren atención',
    informational: 'Informativos',
    times: 'visto %{count} vez |||| visto %{count} veces',
    lastSeen: 'Última vez',
    occurrences: 'Repeticiones',
    kind: {
      critical: 'Aviso crítico',
      maintenance: 'Aviso de mantenimiento',
      info: 'Información',
    },
    titles: {
      cardLow: 'Depósito de tarjetas bajo',
      cardEmpty: 'Depósito de tarjetas vacío',
      reboot: 'Dispositivo reiniciado',
      doorOpen: 'Puerta de servicio abierta',
      maxCards: 'Máximo de tarjetas alcanzado',
      cardFront: 'Tarjeta en la ranura de salida',
      encoder: 'Codificador de tarjetas no detectado',
      comm: 'Sin comunicación con un sistema externo',
      network: 'Problema de conexión del equipo',
      recovery: 'Reintento de recuperación',
      systemError: 'Error interno del equipo',
      jam: 'Atasco en el dispositivo',
      generic: 'Aviso del equipo',
    },
    descs: {
      cardLow: 'Conviene rellenar el depósito pronto. No bloquea la entrega de llaves.',
      cardEmpty: 'No quedan tarjetas. Las próximas entregas fallarán hasta rellenar el depósito.',
      reboot: 'El dispositivo ha vuelto a estar operativo. No requiere ninguna acción.',
      doorOpen: 'Cierre la puerta de servicio para continuar la operación.',
      maxCards: 'Se ha alcanzado el número máximo de tarjetas para la reserva.',
      cardFront: 'Retire la tarjeta insertada por la ranura de salida.',
      encoder: 'No se detecta el codificador de tarjetas. Revise el equipo.',
      comm: 'El equipo no se comunica con un sistema externo. Compruébelo cuando sea posible.',
      network: 'El equipo ha tenido problemas de conexión. Compruebe la conectividad.',
      recovery: 'El equipo ha reintentado una recuperación automática.',
      systemError: 'El equipo ha registrado un error interno. Revíselo cuando sea posible.',
      jam: 'Posible atasco. Revise el mecanismo del dispositivo.',
      generic: 'El equipo ha emitido un aviso. Revíselo cuando sea posible.',
    },
  },

  // Plain, guest-facing friction messages (never raw codes)
  issues: {
    documentInvalid: 'Documento no válido',
    qrInvalid: 'Código QR no válido',
    reservationNotFound: 'Reserva no encontrada',
    roomNotReady: 'Habitación no disponible',
    earlyArrival: 'Llegada anticipada',
    checkinFailed: 'No se ha podido finalizar el check-in',
    paymentFailed: 'Pago rechazado',
    keyFailed: 'Error al entregar la llave',
    deviceFault: 'Revisar el equipo',
    generic: 'Incidencia detectada',
    notice: 'Aviso del equipo',
    cardLow: 'Quedan pocas tarjetas',
    maxCards: 'Máximo de tarjetas de la reserva alcanzado',
    slowIdentify: 'Lleva tiempo identificándose',
    slowPay: 'Lleva tiempo en el pago',
    slowKey: 'Lleva tiempo en la entrega de llave',
    slowGeneric: 'Lleva tiempo en el proceso',
  },

  updatedAgo: 'actualizado hace %{time}',
};

export default activityMonitor;
